import { GuestArea } from '@polvo-labs/react-auth'
import React from 'react'
import { Link as RouterLink, useHistory } from 'react-router-dom'
import Modal from '../../components/Modal'
import Text from '../../components/Text'
import routes from '../../config/routes'
import LoginForm from '../../forms/Login'
import RegisterForm from '../../forms/Register'
import { Container, Form, Link } from './styles'

interface Props {}

const LoginScreen: React.FC<Props> = () => {
  const history = useHistory()

  return (
    <GuestArea>
      <Modal
        open
        title="LOGIN"
        onToggle={() => history.push(routes.index.path)}
      >
        <Container>
          <Form
            style={{ minHeight: '355px' }}
          >
            <Text
              tag="h2"
              align="center"
            >
              ACESSAR MINHA CONTA
            </Text>

            <LoginForm />

            <Link
              to={routes.forgot.path}
            >Esqueci minha senha</Link>
          </Form>

          <Form
            style={{ minHeight: '527px' }}
          >
            <Text
              tag="h2"
              align="center"
            >
              CRIAR UMA CONTA
            </Text>
            <RegisterForm />
          </Form>
        </Container>
      </Modal>
    </GuestArea>
  )
}

export default LoginScreen
